module.exports = __webpack_public_path__ + "img/c10.be50e1b0.png";